'use client'

import React from 'react';
import { useAtom } from 'jotai';
import { activeMiniAppAtom } from '@sourcepilot/ui/framework/state/session-data';
import { TooltipTrigger, TooltipContent, Tooltip } from "@sourcepilot/ui/framework/ui/atoms/tooltip";

interface SidebarButtonProps {
  appLabel: string;
  children: React.ReactNode;
}

const SidebarButton: React.FC<SidebarButtonProps> = ({ appLabel, children }) => {
  const [activeMiniApp, setActiveMiniApp] = useAtom(activeMiniAppAtom);

  const handleClick = () => {
    if (activeMiniApp === appLabel) {
      setActiveMiniApp(null);
    } else {
      setActiveMiniApp(appLabel);
    }
  };

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          onClick={handleClick}
          // The button's only content is an icon, so without this it has no
          // accessible name at all: a screen reader announces "button", and
          // a test can address it only by position in the sidebar — which
          // shifts with the registered mini-apps and with admin mode.
          aria-label={appLabel}
          className={`w-12 h-12 flex items-center justify-center hover:text-[#00ccaa] underline ${activeMiniApp === appLabel ? 'text-[#00ccaa]' : ''}`}
        >
          {children}
        </button>
      </TooltipTrigger>
      <TooltipContent>{appLabel}</TooltipContent>
    </Tooltip>
  );
};

export default SidebarButton; 